import { useState } from 'react';

interface UseSampleModelOptions {
  onDrop: (file: File) => void;
}

interface UseSampleModelReturn {
  isLoading: boolean;
  error: string | null;
  loadSampleModel: (sampleName: string) => Promise<void>;
}

export const useSampleModel = ({ onDrop }: UseSampleModelOptions): UseSampleModelReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getSampleFile = async (sampleName: string): Promise<File> => {
    const sampleFileResponse = await fetch(`/_hub/models/sample${sampleName}.stp`);
    if (!sampleFileResponse.ok) {
      throw new Error('Failed to fetch sample file');
    }
    const sampleFileBlob = await sampleFileResponse.blob();
    return new File([sampleFileBlob], `sample${sampleName}.stp`, { type: 'application/step' });
  };

  const loadSampleModel = async (sampleName: string): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      const file = await getSampleFile(sampleName);
      onDrop(file);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to load sample model';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, loadSampleModel };
};
